import React from 'react';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Email from 'material-ui/svg-icons/communication/email';
import Count from '../parts/Counter';
import './Extent.css';
import api from '../../services/api';

class Extent extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {withEmail: null,
                  withEmailPersonal: null,
                  withEmailUsp:null,
                withoutEmail:null};    
  }
  componentDidMount(){    
    api.getExtent().then((rs) => {              
        this.setState({withEmail:rs.response.withEmail+rs.response.withEmailUsp});
        this.setState({withEmailPersonal:rs.response.withEmail});        
        this.setState({withEmailUsp:rs.response.withEmailUsp});        
        this.setState({withoutEmail:rs.response.withoutEmail});        
      })
      .catch((error) => {        
        console.error(error);
      });      
  }
  render(){
    var mainIconStyle = {width:"50px",height:"50px",color:"white"};
    var headStyle = {marginTop:"-30px"};
    var cardStyle = {marginTop:"50px"};
    
    var withEmail = this.state.withEmail;
    var withEmailPersonal = this.state.withEmailPersonal;
    var withEmailUsp = this.state.withEmailUsp;
    var withoutEmail = this.state.withoutEmail;
    return (      
      <div className="extent-main">
        <h1>Alcance</h1>
        <Count label="Alumni com email" count={withEmail} color="green" icon={Email} />
        <Count label="Alumni com email pessoal" count={withEmailPersonal} color="blue" icon={Email} />
        <Count label="Alumni com email USP" count={withEmailUsp} color="orange" icon={Email} />        
        <Count label="Alumni sem email" count={withoutEmail} color="red" icon={Email} />        
      </div>      
    )
    }
};

export default Extent;


// WEBPACK FOOTER //
// ./src/pages/reports/Extent.js